import { ImagesService } from "../../../../server/cloudflare/images-service";
import { resizeImageFromUrl } from "../../../../utils/resize-image";
import { uuidv4 } from "../../../../utils/uuid";
import { DesignHuddleNode } from "../nodes/design-huddle-node";
import { ImageNode } from "../nodes/image-node";
import { VideoNode } from "../nodes/video-node";

export async function getNewImageUrl(
  node: ImageNode | DesignHuddleNode | VideoNode,
  imageResize: { maxWidth: number; token: string },
): Promise<{ node: ImageNode | DesignHuddleNode | VideoNode; url: string } | null> {
  const url =
    node instanceof ImageNode
      ? node.__url
      : node instanceof VideoNode
        ? node.__thumbnailUrl
        : node.getImageUrl();
  if (node.__proportionOfMaxWidth === 1 || url.endsWith(".gif")) return { node, url };

  const newImg = await resizeImageFromUrl(
    url,
    {
      width: (node.__proportionOfMaxWidth ?? 1) * imageResize.maxWidth,
      height: ((node.__proportionOfMaxWidth ?? 1) * imageResize.maxWidth) / (node.__aspect ?? 1),
    },
    node.__type === "design-huddle",
  );

  const id = uuidv4();

  const resp = await new ImagesService().upload(newImg, id, imageResize.token);
  if (resp.url) return { node, url: resp.url };

  return null;
}
